import { inject, Injectable } from '@angular/core';

import { EngineFileDownloads } from '@blaze-runtime/workflow-feature';
import { API_BASE_URL, FileDownloadService } from '@blaze-shared/platform-data-access';
import { urlUtils } from '@blaze-shared/platform-util';
import { SecureFileApiService } from '@blaze-shared/projects-data-access';
import { isIOS } from '@blaze-shared/shared-util';

import { getFileFromUrl } from '../utils/data/file.utils';

@Injectable({ providedIn: 'root' })
export class FileService extends EngineFileDownloads {
  private readonly apiBaseUrl = inject(API_BASE_URL);
  private readonly fileDownloadService = inject(FileDownloadService);
  private readonly secureFileApiService = inject(SecureFileApiService);

  downloadSecureFile(fileUrl: string): void {
    const encodedFileUrl = urlUtils.encodeFileUrl(fileUrl);
    this.secureFileApiService
      .getSecureFileAccessToken(encodedFileUrl)
      .subscribe(({ isBlazeHost, url }) => {
        const { filename } = getFileFromUrl(fileUrl) ?? {};
        // Download file
        const a = document.createElement('a');
        if (isBlazeHost && isIOS()) {
          url = this.changeUrlToBlazeHost(url);
        } else {
          a.setAttribute('download', filename || 'blaze-file');
          a.setAttribute('target', '_blank');
        }
        a.setAttribute('href', url);
        a.setAttribute('rel', 'noopener noreferrer');
        a.click();
      });
  }

  downloadFile(url: string): void {
    this.fileDownloadService.downloadFile(url);
  }

  private changeUrlToBlazeHost(url: string): string {
    let baseUrl = `${this.apiBaseUrl}/media/directdownload`;
    if (this.apiBaseUrl.endsWith('/api')) {
      baseUrl = this.apiBaseUrl.replaceAll('/api', '/media/directdownload');
    }
    return `${baseUrl}?url=${encodeURIComponent(url)}`;
  }
}
